import { ALL_DATA_TYPES } from '@repo/advanced-filters';
import { DateTimeInput } from '@repo/ui';
import {
  Checkbox, Flex, Typography,
} from 'antd';
import dayjs from 'dayjs';
import {
  useCallback, useState,
} from 'react';

import MailMergeInput from './MailMergeInput';
import styles from './WaitNodeMenu.module.scss';

export default function CustomWaitContent({
  disabled,
  initialValue,
  onChange,
}: {
  disabled: boolean;
  initialValue?: string;
  onChange: (value: string) => void;
}) {
  const [useMailMerge, setUseMailMerge] = useState(false);

  const handleChange = useCallback((date: Date | null) => {
    if (onChange && date?.toISOString() !== initialValue) {
      onChange(date?.toISOString() ?? '');
    }
  }, [onChange, initialValue]);

  const handleMailMergeInputChange = useCallback((value: string) => {
    if (onChange && value !== initialValue && !disabled) {
      onChange(value);
    }
  }, [onChange, initialValue, disabled]);

  return (
    <Flex vertical gap={8}>
      <Typography.Text>
        Till a specific date & time
      </Typography.Text>
      <Flex gap={16}>
        {useMailMerge ? (
          <MailMergeInput
            onChange={handleMailMergeInputChange}
            disabled={disabled}
            initialValue={initialValue}
            allowedDataTypes={[ALL_DATA_TYPES.datetime, ALL_DATA_TYPES.date]}
          />
        ) : (
          <Flex gap={8}>
            <DateTimeInput
              initialValue={dayjs(initialValue).isValid() ? initialValue : undefined}
              onChange={handleChange}
              dateInputProps={{ disabled }}
              timeInputProps={{ disabled }}
            />
          </Flex>
        )}
        {!disabled && (
          <Checkbox
            checked={useMailMerge}
            onChange={(e) => setUseMailMerge(e.target.checked)}
            className={styles.mailMergeCheckbox}
            disabled={disabled}
          >
            Use Mail Merge
          </Checkbox>
        )}
      </Flex>
    </Flex>
  );
}
